import { z } from 'zod'

export const DocumentKind = z.enum(['past_quote', 'rate_card', 'scope', 'reference'])
export type DocumentKind = z.infer<typeof DocumentKind>

export const DocumentStatus = z.enum(['uploaded', 'processing', 'indexed', 'error'])
export type DocumentStatus = z.infer<typeof DocumentStatus>

/** What the indexer pulls out of a document. Every field is optional on purpose:
 *  a rate card has no customer, a scope doc has no total. */
export const DocumentMetadataSchema = z.object({
  customer: z.string().nullable().optional(),
  issued_on: z.string().nullable().optional(),
  currency: z.string().nullable().optional(),
  total: z.number().nullable().optional(),
  industry: z.string().nullable().optional(),
  tags: z.array(z.string()).optional(),
})
export type DocumentMetadata = z.infer<typeof DocumentMetadataSchema>

export const QuoteDocumentSchema = z.object({
  id: z.string().uuid(),
  organization_id: z.string().uuid(),
  uploaded_by: z.string().uuid(),
  filename: z.string(),
  content_type: z.string(),
  byte_size: z.number().int(),
  file_hash: z.string(),
  kind: DocumentKind,
  status: DocumentStatus,
  error_reason: z.string().nullable(),
  text_preview: z.string().nullable(),
  char_count: z.number().int(),
  chunk_count: z.number().int(),
  metadata: DocumentMetadataSchema.passthrough(),
  indexed_at: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
})
export type QuoteDocument = z.infer<typeof QuoteDocumentSchema>

/** Extensions the upload endpoint and the file picker both accept. */
export const ACCEPTED_UPLOAD_EXTENSIONS = [
  '.pdf',
  '.docx',
  '.txt',
  '.md',
  '.csv',
  '.tsv',
  '.json',
  '.html',
  '.htm',
] as const

export const MAX_UPLOAD_BYTES = 25 * 1024 * 1024
